export default "__VITE_ASSET__4843fab0__"